export default __webpack_public_path__ + "static/media/Banner - AirLockz - Pink.b8db634a.jpg";